import React from 'react'
import InlineEditUI from '../../../widgets/input/InlineEditUI'
import './RowLeft.css'

const RowLeftUI = ({context, messageList, project, task, currentTask, onSetEditMode,
    onUnfoldClick, onFoldClick, onTaskNameCreateOrUpdate,
    unfoldedTaskIdSet
  }) =>
  <React.Fragment>
    {
      task.taskList.length > 0 && !unfoldedTaskIdSet.has(task.taskId) &&
      <div className='icon icon-angle-right' onClick={onUnfoldClick} data-task-id={task.taskId}></div>
    }
    {
      task.taskList.length > 0 && unfoldedTaskIdSet.has(task.taskId) &&
      <div className='icon icon-angle-down' onClick={onFoldClick} data-task-id={task.taskId}></div>
    }
    {
      task.taskList.length === 0 &&
      <div className='icon icon-angle-right reserve-space'></div>
    }

    <div>
      <div className='g_flex_h'>
        <InlineEditUI
          context={context}
          value={task.taskName}
          messageList={messageList}
          onValueUpdate={onTaskNameCreateOrUpdate}
          onSetEditMode={onSetEditMode}
          editable={project.permissionList.includes('prj_participate')}
          editMode={task.editMode}
          dataId={task.taskId}
          editingOther={currentTask && currentTask.taskId !== task.taskId && currentTask.editMode}
        />
        {
          task.status === 'done' &&
          <div className='icon icon-check tag'></div>
        }
        {
          task.status === 'todo' && task.dueDateDaysStr &&
          <div className={`due ${task.dueDateDays > 0 ? 'future' : 'past'} tag`}>{task.dueDateDaysStr}</div>
        }
      </div>
      {
        task.notes &&
        <div className='g_muted g_small'>
          {task.notes}
        </div>
      }
    </div>
  </React.Fragment>

export default RowLeftUI
